import { StoreI } from 'ducks/store';
import { NotificationPayloadI } from './Notifications.interface';

export const getNotification = (store: StoreI): NotificationPayloadI => store.notifications;

export default getNotification;
